import { useState } from "react";
import { usePartnerDetail, PartnerLogoPanel, IssuedKeyBox, PartnerKeys, PartnerUsage, PartnerCustomers } from "./PartnerParts";
import { BillingPanel } from "./BillingPanel";
import { WebhooksPanel, SecurityPanel, AuditPanel } from "./PartnerSecurityParts";

export const SECTIONS = ["Overview", "Branding", "API Keys", "Webhooks", "Usage", "Billing", "Customers", "Security", "Audit Log"];
const PLATFORM_SECTIONS = ["Overview", "API Keys", "Usage", "Customers", "Audit Log"];
const slug = (x) => x.toLowerCase().replace(/ /g, "-");

const Field = ({ label, children }) => <div><div className="label-cap">{label}</div>{children}</div>;

function PartnerOverview({ t }) {
  const included = t.included ? `${t.included.customers} cust · ${t.included.active_projects} proj · ${t.included.reviews} rev` : "—";
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-slate-300" data-testid="partner-overview">
      <Field label="Kind">{t.kind}</Field><Field label="Deployment">{t.deployment}</Field><Field label="Active">{t.active ? "yes" : "no"}</Field><Field label="Contact">{t.contact_email || "—"}</Field>
      <Field label="Monthly minimum">${Number(t.monthly_minimum || 0)}</Field><Field label="Included">{included}</Field><Field label="Contract">{t.contract_start || "—"} → {t.contract_end || "—"}</Field><Field label="Billing suspended">{t.billing_suspended_at ? "yes" : "no"}</Field>
    </div>
  );
}

function SectionTabs({ sections, active, onPick }) {
  return (
    <div className="flex flex-wrap gap-1 border-b border-slate-800" data-testid="partner-sections">
      {sections.map((x) => <button key={x} onClick={() => onPick(x)} className={`px-3 py-1.5 border-b-2 -mb-px ${active === x ? "border-amber-500 text-amber-400" : "border-transparent text-slate-400 hover:text-slate-200"}`} data-testid={`partner-section-${slug(x)}`}>{x}</button>)}
    </div>
  );
}

function SectionBody({ sec, t, d, onPurged }) {
  switch (sec) {
    case "Branding": return <PartnerLogoPanel t={t} />;
    case "API Keys": return <PartnerKeys d={d} />;
    case "Webhooks": return <WebhooksPanel t={t} />;
    case "Usage": return <PartnerUsage usage={d.usage} />;
    case "Billing": return <BillingPanel t={t} />;
    case "Customers": return <PartnerCustomers customers={d.customers} />;
    case "Security": return <SecurityPanel t={t} onPurged={onPurged} />;
    case "Audit Log": return <AuditPanel t={t} />;
    default: return <PartnerOverview t={t} />;
  }
}

export function PartnerDetail({ t, onClose, onPurged }) {
  const d = usePartnerDetail(t.id);
  const [sec, setSec] = useState("Overview");
  return (
    <div className="mt-4 border border-amber-500/30 rounded-md p-4 text-xs space-y-4" data-testid="partner-detail">
      <div className="flex items-center justify-between"><div className="font-heading text-base text-slate-100">{t.name} <span className="text-slate-500 font-mono">· {t.deployment} · {t.id}</span></div><button onClick={onClose} className="text-slate-400">Close</button></div>
      <SectionTabs sections={t.id === "platform" ? PLATFORM_SECTIONS : SECTIONS} active={sec} onPick={setSec} />
      <IssuedKeyBox issued={d.issued} />
      <SectionBody sec={sec} t={t} d={d} onPurged={() => { onClose(); onPurged(); }} />
    </div>
  );
}
